// @ts-nocheck
export const AppRoute = {
  Index: '/',
  AuthCallback: '/auth/callback',
  Customers: '/customers',
  CustomerDetails: '/customers/:userId',
  Vouchers: '/vouchers',
  Campaigns: '/campaigns',
  CampaignDetails: '/campaigns/:campaignId',
  ServiceMessages: '/serviceMessages',
  Companies: '/companies',
  CompanyDetails: '/companies/:companyId',
  ContractDetails: '/companies/:companyId/contracts/:contractId',
  Products: '/products',
  ProductDetails: '/products/:productId',
  Promotions: '/promotions',
  PromotionDetails: '/promotions/:promotionId',
};
